import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { schemaTemplatesMailFooter } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_GetFooters = schemaTemplatesMailFooter
    .pick({
        createdAt: true,
        data: true,
        id: true,
        type: true,
    })
    .nullable();

export type SchemaTemplateResolver_GetFooters = z.infer<typeof schemaTemplateResolver_GetFooters>;

export type TemplateResolver_GetFooters = Resolver<Arguments, SchemaTemplateResolver_GetFooters>;
